export class InputAccessoriesCapability {
	isKeyboardMapAvailable: boolean;
	isUdkAvailable: boolean;
	isVoipAvailable: boolean;
	image = '';
	additionalCapabilitiesObj: any;
	keyboardVersion: string;
	keyboardMachineType: string;
	keyboardLayoutName: any;
	fnLockCapability: boolean;
	fnCtrlSwapCapability: boolean;
}
